// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__OfYMN","disabled":"FileBtn_disabled__2sJ5Z","warn":"FileBtn_warn__2OYYe","fade":"FileBtn_fade__2i9cb"};